export default __webpack_public_path__ + "static/media/logo-white.de51da81.png";